export const getCols = (brands?: any, benchmark?: any) => {
  const [currentBrand, ...rest] = brands || []
  return [currentBrand, benchmark, ...rest]
}
